export default {
  openCombobox: `Открыть`,
  createNew   : `(Создать новое значение)`,
  emptyList   : `Список пуст`,
  emptyFilter : `Ничего не найдено`,
}
